import { render, staticRenderFns } from "./ChatWelcome.vue?vue&type=template&id=f9154e08&scoped=true&"
import script from "./ChatWelcome.vue?vue&type=script&lang=js&"
export * from "./ChatWelcome.vue?vue&type=script&lang=js&"
import style0 from "./ChatWelcome.vue?vue&type=style&index=0&id=f9154e08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9154e08",
  null
  
)

export default component.exports